import { AxiosInstance } from "axios"

import type { TransactionResponse } from "../../../../../modules/payments/transactionTypes"

import {
    CreateTakeawayOrderRequest,
    TakeawayKitchensResponse,
    TakeawayMenuResponse,
    TakeawayOrderDelivery,
    TakeawayPaymentDetailsResponse,
    TakeawayProductFavoritesResponse,
} from "./takeawayTypes"

export enum TakeawayQuery {
    TAKEAWAY_MENU = "takeaway-menu",
    TAKEAWAY_KITCHENS = "takeaway-kitchens",
    TAKEAWAY_PAYMENT_DETAILS = "takeaway-payment-details",
    TAKEAWAY_FAVORITES = "takeaway-favorites",
}

export enum TakeawayMutation {
    CREATE_ORDER = "takeaway-create-order",
}

type TakeawayMenuParams = Readonly<{
    kitchenId: number
    date: string
}>

export async function fetchTakeawayMenu(
    { kitchenId, date }: TakeawayMenuParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<TakeawayMenuResponse> {
    const { data } = await axios.get(`suppliers/kitchens/${kitchenId}/menues/takeaway`, {
        params: { date },
        signal,
    })
    return data
}

type TakeawayPaymentDetailsParams = Readonly<{
    kitchenId: number
    deliveries: TakeawayOrderDelivery[]
}>

export async function fetchTakeawayPaymentDetails(
    { kitchenId, deliveries }: TakeawayPaymentDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<TakeawayPaymentDetailsResponse> {
    const url = `suppliers/kitchens/${kitchenId}/payment/paymentDetails/takeaway`
    const { data } = await axios.post(url, { deliveries }, { signal })
    return data
}

type CreateTakeawayOrderParams = Readonly<{
    request: CreateTakeawayOrderRequest
}>

export async function createTakeawayOrder(
    { request }: CreateTakeawayOrderParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<TransactionResponse> {
    const url = `orders/takeaway`
    const { data } = await axios.post(url, request, { signal })
    return data
}

type TakeawayFavoritesParams = Readonly<Record<string, never>>

export async function fetchProductFavorites(
    _: TakeawayFavoritesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<TakeawayProductFavoritesResponse> {
    const { data } = await axios.get(`/organization/company/user/productFavorites`, { signal })
    return data
}

type TakeawayKitchensParams = Readonly<Record<string, never>>

export async function fetchTakeawayKitchens(
    _: TakeawayKitchensParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<TakeawayKitchensResponse> {
    const { data } = await axios.get(`suppliers/kitchens/takeaway`, { signal })
    return data
}
